/* eslint-disable-next-line max-len */
export { default as ImageRowWithHeadingAndButton } from './ImageRowWithHeadingAndButton';
